import { Box, Button, Chip, Typography } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { useAuth } from '@/context/AuthContext';
import { Team } from '@/types';

const statusColors: Record<string, 'default' | 'success' | 'warning' | 'error' | 'info'> = {
  pending: 'warning',
  approved: 'success',
  rejected: 'error',
  revision_requested: 'info',
};

interface TeamHeaderProps {
  team: Team;
  onDelete?: () => void;
}

export default function TeamHeader({ team, onDelete }: TeamHeaderProps) {
  const { user } = useAuth();

  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'stretch', sm: 'flex-start' }, gap: 2, mb: 3 }}>
      <Box>
        <Typography variant="h5" gutterBottom>
          {team.name}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip
            label={team.approval_status}
            color={statusColors[team.approval_status] || 'default'}
            size="small"
          />
          {team.is_active ? (
            <Chip label="Active" color="success" size="small" variant="outlined" />
          ) : (
            <Chip label="Inactive" color="default" size="small" variant="outlined" />
          )}
        </Box>
      </Box>
      {user?.isAdmin && onDelete && (
        <Button
          variant="outlined"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={onDelete}
        >
          Delete Team
        </Button>
      )}
    </Box>
  );
}
